import type { ComponentProps, ReactNode } from 'react';

import Banner from '../../../components/Banner/Banner';
import DialogModal from '../../../components/DialogModal/DialogModal';
import Inline from '../../../components/Inline/Inline';
import Stack from '../../../components/Stack/Stack';
import Title from '../../../components/Title/Title';
import useTrans from '../../../hooks/ui/useTrans';
import Button from '../Button/Button';

type ConfirmationDialogProps = {
    title?: ReactNode;
    onConfirm: () => void;
    onCancel?: () => void;
    children: ReactNode;
    iconLevel?: ComponentProps<typeof Banner>['level'];
};

const ConfirmationDialog = ({
    title,
    onConfirm,
    onCancel,
    children,
    iconLevel = 'warning',
}: ConfirmationDialogProps) => {
    const trans = useTrans('CustomerArea.Shared.ConfirmationDialog.');
    const titleOrDefault = title ?? trans('Title');

    return (
        <DialogModal
            onCloseRequested={onCancel ?? onConfirm}
            isOpen
            width="regular"
        >
            <Stack>
                <Title>{titleOrDefault}</Title>

                <Banner level={iconLevel} withoutBackground>
                    {children}
                </Banner>

                <Inline horizontal="right">
                    {onCancel && (
                        <Button variant="subtle" onClick={onCancel}>
                            {trans('CancelButton')}
                        </Button>
                    )}

                    <Button onClick={onConfirm}>
                        {trans('ConfirmButton')}
                    </Button>
                </Inline>
            </Stack>
        </DialogModal>
    );
};

export default ConfirmationDialog;
